/**
 * Root module of entire application
 */
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {APP_INITIALIZER, inject, NgModule} from '@angular/core';
import {HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {CoreModule} from './@core/core.module';
import {ThemeModule} from './@theme/theme.module';
import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {
    NbAutocompleteModule,
    NbButtonModule,
    NbCardModule, NbCheckboxModule, NbContextMenuModule,
    NbDatepickerModule,
    NbDialogModule,
    NbIconModule, NbLayoutModule, NbListModule,
    NbMenuModule, NbRadioModule, NbSelectModule,
    NbSidebarModule, NbSpinnerModule, NbTabsetModule, NbTooltipModule
} from '@nebular/theme';
import {NbEvaIconsModule} from '@nebular/eva-icons';
import {NgxFileDropModule} from 'ngx-file-drop';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule} from '@angular/material/core';
import {AuthInterceptor} from './@modules/auth/interceptors/auth.interceptor';
import {LoaderInterceptorService} from './@modules/shared/services/interceptors/loader-interceptor.service';
import {ToastrModule} from 'ngx-toastr';
import {NgSelectModule} from '@ng-select/ng-select';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {NgxSkeletonLoaderModule} from 'ngx-skeleton-loader';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {DataSourceUploadProgressModalComponent} from './@modules/data-source/components/dialogs/data-source-upload-progress-modal/data-source-upload-progress-modal.component';
import {SharedModule} from './@modules/shared/shared.module';
import {BlobErrorInterceptorServices} from "./@modules/shared/services/interceptors/blob-error-interceptor.services";
import {FixDataInterceptor} from "./@modules/shared/services/interceptors/fix-data.interceptor";
import {tap, Observable} from "rxjs";
import {FeatureToggleService} from "./@modules/shared";

const NEBULAR_MODULES = [
    NbCardModule,
    NbIconModule,
    NbCheckboxModule,
    NbSelectModule,
    NbContextMenuModule,
    NbSidebarModule,
    NbMenuModule,
    NbButtonModule,
    NbDialogModule.forChild(),
    NbTabsetModule,
    NbTooltipModule,
    NgSelectModule,
    NbSpinnerModule,
    NbListModule,
    NbAutocompleteModule,
    NbRadioModule,
    NbLayoutModule,
];

  function initializeAppFactory(httpClient: HttpClient): () => Observable<any> {
   return () => httpClient.get("/features.json")
     .pipe(tap(features => {
       FeatureToggleService.features.next(features)
     }));
  }

@NgModule({
  declarations: [AppComponent, DataSourceUploadProgressModalComponent],
  bootstrap: [AppComponent],
  imports: [
    ...NEBULAR_MODULES,
    BrowserModule,
    BrowserAnimationsModule,

    AppRoutingModule,
    CoreModule.forRoot(),
    ThemeModule,
    ThemeModule.forRoot(),
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDialogModule.forRoot(),
    NbDatepickerModule.forRoot(),
    ToastrModule.forRoot(),
    NgxFileDropModule,
    NbEvaIconsModule,
    SharedModule,
    NbCardModule,
    NbTooltipModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgSelectModule,
    DragDropModule,
    ToastrModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
      defaultLanguage: 'fa',
    }),
    NgxSkeletonLoaderModule.forRoot({animation: 'progress'})],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptorService,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BlobErrorInterceptorServices,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: FixDataInterceptor,
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAppFactory,
      multi: true,
      deps: [HttpClient],
    },
  ]
})
export class AppModule {
}

/*eslint-disable */
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
